import type { StakeItem, StrategicStakes } from "@/db/schema/content-items";

/**
 * Sérialise les enjeux stratégiques structurés en texte, pour réinjection dans
 * les prompts en aval (placeholder {{enjeux}} de buildPromptWithBrief). Garde le
 * format en puces attendu par les autres prompts.
 */
export function stakesToText(
  stakes: StrategicStakes | string | null | undefined
): string {
  // Tolère les anciennes offres où strategicStakes était une string.
  if (typeof stakes === "string") return stakes;
  if (!stakes || !Array.isArray(stakes.items) || stakes.items.length === 0) return "";
  const lines: string[] = [];
  for (const raw of stakes.items) {
    const item = normalizeStakeItem(raw);
    if (!item) continue;
    const cat = item.category ? `[${item.category}] ` : "";
    lines.push(`- ${cat}${item.enjeu}`);
    if (item.probleme) lines.push(`  Problématique : ${item.probleme}`);
    if (item.solution) lines.push(`  Solution : ${item.solution}`);
    if (item.resultat) lines.push(`  Résultat : ${item.resultat}`);
  }
  return lines.join("\n");
}

/** Nettoie un item brut (IA ou formulaire) ; renvoie null si l'enjeu est vide. */
export function normalizeStakeItem(raw: unknown): StakeItem | null {
  const e = (raw ?? {}) as Record<string, unknown>;
  const str = (v: unknown) => (typeof v === "string" ? v.trim() : "");
  const enjeu = str(e.enjeu);
  if (!enjeu) return null;
  return {
    category: str(e.category),
    enjeu,
    probleme: str(e.probleme),
    solution: str(e.solution),
    resultat: str(e.resultat ?? e.userCapability ?? e.user_capability),
  };
}

/** Item vide pour l'ajout manuel dans le formulaire. */
export function emptyStakeItem(): StakeItem {
  return { category: "", enjeu: "", probleme: "", solution: "", resultat: "" };
}
